import { useState } from 'react'
import { Link, Dialog } from '@material-ui/core'
import {
  List,
  Datagrid,
  SearchInput,
  Filter,
  TextField,
  useRefresh,
  useDataProvider,
  useNotify,
  SimpleForm,
  TextInput,
  ShowButton,
  useRecordContext,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  BooleanInput,
} from 'react-admin'
import moment from 'moment'
import { ExtraPagination, openInNewTab } from '../utils'
import { DialogForm } from '../components/DialogForm'
import TextFieldWithTooltip from '../components/text_field_with_tooltip'
import Pill from '../components/pill'
import CheckIcon from '@mui/icons-material/Check'
import { Divider, Tabs, Tab, Button as ButtonM } from '@material-ui/core'
import { useNavigate } from 'react-router'

const PER_PAGE = 100

const TabsComponent = (props) => {
  const navigate = useNavigate()
  const { id } = props
  const tabs_items = [
    { id: 'ag_current', name: 'AGs en cours', route: 'a' },
    { id: 'ag_future', name: 'Ags à venir', route: 'b' },
    { id: 'AGs archivées', name: 'AGs archivées', route: 'c' },
  ]
  const [tab, setTab] = useState(tabs_items[props.idx].id)
  const handleChange = (event, value) => {
    var idx = tabs_items.findIndex((obj) => obj.id === value)
    var nb = tabs_items[idx]['route']
    navigate(`/ags1${nb}`)
  }
  return (
    <div>
      <Tabs
        variant="fullWidth"
        centered
        value={tab}
        indicatorColor="primary"
        onChange={handleChange}
      >
        {tabs_items.map((choice) => (
          <Tab key={choice.id} label={choice.name} value={choice.id} />
        ))}
      </Tabs>
      <Divider />
    </div>
  )
}

const AGFilter = (props) => {
  const [copro_manager_id, setCoproManagerId] = useState(-1)

  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn />
      <TextInput fullWidth source="id" label="Ref" />
      <ReferenceInput source="copro_manager_id" reference="users">
        <AutocompleteInput
          sx={{ width: 300, ' button': { padding: '4px;' } }}
          optionValue="id"
          optionText={(record) => {
            return `${record.firstname} ${record.lastname}`
          }}
          size="small"
          resettable={false}
          clearAlwaysVisible={false}
          onChange={(val) => {
            setCoproManagerId(val === '' ? undefined : val)
          }}
          matchSuggestion={() => true}
        />
      </ReferenceInput>
      <SelectInput
        sx={{ margin: 0 }}
        label="Statut du contrat"
        source="contract_status"
        choices={[
          { id: 'À faire', name: 'À faire' },
          { id: 'À envoyer', name: 'À envoyer' },
          { id: 'Envoyé', name: 'Envoyé' },
          { id: 'Signé', name: 'Signé' },
          { id: 'Pas de contrat', name: 'Pas de contrat' },
        ]}
      />
      <SelectInput
        sx={{ margin: 0 }}
        label="Statut convocation"
        source="convocation_triggered_at"
        choices={[
          { id: 'null', name: 'À envoyer' },
          { id: 'not_null', name: 'Envoyé' },
        ]}
      />
      <BooleanInput
        sx={{ marginLeft: '10px' }}
        source="check_doc_ok"
        label="Docs signés"
      />
      <BooleanInput
        sx={{ marginLeft: '10px' }}
        source="check_pv_ok"
        label="PV envoyé"
      />
      <BooleanInput
        sx={{ marginLeft: '10px' }}
        source="check_ops_ok"
        label="Check ops"
      />
      <BooleanInput
        sx={{ marginLeft: '10px' }}
        source="check_finance_ok"
        label="Check finance"
      />
      <BooleanInput
        sx={{ marginLeft: '10px' }}
        source="check_recours_ok"
        label="Recours"
      />
    </Filter>
  )
}

const LinkField = () => {
  const record = useRecordContext()
  record.external = window.location.origin + '/ext_ags2/' + record.code

  return (
    <Link
      onClick={(e) => e.stopPropagation()}
      href={record.external}
      target="_blank"
      rel="noopener noreferrer"
    >
      Voir
    </Link>
  )
}

const AgDateField = (props) => {
  const record = useRecordContext()
  const agDate = moment(record.dateprevisionnelle)
  const today = moment()
  const isPast = moment(agDate).isBefore(today)

  return (
    <div style={{ display: 'inline-flex' }}>
      <Pill
        id={record.id}
        value={agDate.format('D/M/Y HH:mm')}
        status={isPast ? 'error' : 'success'}
      />
      {props.enregistr ? (
        <CircularProgressWithLabel label="" value={record.enregistr_progress} />
      ) : null}
    </div>
  )
}

const CoproManagersField = () => {
  const record = useRecordContext()
  if (!record || !record.copro_managers) return null

  return record.copro_managers.join(', ')
}

const StatusField = ({ source }) => {
  const record = useRecordContext()
  // Fake data, waiting for the backend
  const status_value = record[source]
  const status = status_value ? 'success' : 'error'
  const value = status_value ? 'Fait' : 'A faire'

  return <Pill id={record.id} value={value} status={status} />
}

const ContractStatusField = ({ source }) => {
  const record = useRecordContext()
  const status_value = record[source]

  let status = ''

  if (status_value === 'Signé') {
    status = 'success'
  } else if (['À faire', 'À envoyer', 'Envoyé'].includes(status_value)) {
    status = 'error'
  } else if (status_value === 'Pas de contrat') {
    status = 'light'
  } else {
    status = 'error'
  }

  return (
    <Pill
      id={record.id}
      value={status_value}
      status={status}
      {...(status_value === 'Pas de contrat'
        ? { size: 'large', color: 'black' }
        : {})}
    />
  )
}

const ConvocationStatusField = ({ source }) => {
  const record = useRecordContext()
  const statusValue = record[source]

  let status
  let displayValue

  if (statusValue !== null && statusValue !== undefined) {
    status = 'success'
    displayValue = 'Envoyé'
  } else {
    status = 'error'
    displayValue = 'À envoyer'
  }

  return <Pill id={record.id} value={displayValue} status={status} />
}

import CircularProgressWithLabel from '../components/circular_progress'
import AdresseField from '../components/AddressField'

export const AgList1 = (props) => {
  return (
    <div>
      <TabsComponent idx={0} {...props} />
      <List
        {...props}
        exporter={false}
        sort={{ field: 'datePrevisionnelle', order: 'DESC' }}
        pagination={<ExtraPagination />}
        filters={<AGFilter />}
        perPage={PER_PAGE}
        filter={{ archived: false, future: false }}
      >
        <Datagrid
          rowClick={(id) => {
            openInNewTab(`/ags1a/${id}/show`)
          }}
          bulkActionButtons={false}
        >
          <TextField source="code" label="Code AG" />
          <TextFieldWithTooltip
            source="libelle"
            label="Libellé"
            maxLength={100}
          />
          <AdresseField label="Adresse" maxLength={30} />
          <TextFieldWithTooltip
            source="exercice_libelle"
            label="Exercice(s)"
            maxLength={20}
          />
          <AgDateField label="Date/Enregist." enregistr={true} />
          <CoproManagersField label="Copro managers" />
          <ConvocationStatusField
            label="Convocation"
            source="convocation_triggered_at"
          />
          <StatusField label="Doc signés" source="check_doc_ok" />
          <StatusField label="PV envoyé" source="check_pv_ok" />
          <StatusField label="Check finance" source="check_finance_ok" />
          <StatusField label="Recours" source="check_recours_ok" />
          <ContractStatusField
            label="Statut du contrat"
            source="contract_status"
          />
        </Datagrid>
      </List>
    </div>
  )
}

export const AgList2 = (props) => {
  return (
    <div>
      <TabsComponent idx={1} {...props} />
      <List
        {...props}
        exporter={false}
        sort={{ field: 'datePrevisionnelle', order: 'DESC' }}
        pagination={<ExtraPagination />}
        filters={<AGFilter />}
        perPage={PER_PAGE}
        filter={{ future: true }}
      >
        <Datagrid
          rowClick={(id) => {
            openInNewTab(`/ags1b/${id}/show`)
          }}
          bulkActionButtons={false}
        >
          <TextField source="code" label="Code AG" />
          <TextFieldWithTooltip
            source="libelle"
            label="Libellé"
            maxLength={100}
          />
          <TextFieldWithTooltip
            source="exercice_libelle"
            label="Exercice(s)"
            maxLength={20}
          />
          <AgDateField label="Date" />
          <CoproManagersField label="Copro managers" />
          <ConvocationStatusField
            label="Convocation"
            source="convocation_triggered_at"
          />
          <StatusField label="Doc signés" source="check_doc_ok" />
          <StatusField label="PV envoyé" source="check_pv_ok" />
          <StatusField label="Check ops" source="check_ops_ok" />
          <StatusField label="Check finance" source="check_finance_ok" />
          <StatusField label="Recours" source="check_recours_ok" />
          <ContractStatusField
            label="Statut du contrat"
            source="contract_status"
          />
          <LinkField label="Espace AG" />
        </Datagrid>
      </List>
    </div>
  )
}

export const AgList3 = (props) => {
  return (
    <div>
      <TabsComponent idx={2} {...props} />
      <List
        {...props}
        exporter={false}
        sort={{ field: 'datePrevisionnelle', order: 'DESC' }}
        pagination={<ExtraPagination />}
        filters={<AGFilter />}
        perPage={PER_PAGE}
        filter={{ archived: true }}
      >
        <Datagrid
          rowClick={(id) => {
            openInNewTab(`/ags1c/${id}/show`)
          }}
          bulkActionButtons={false}
        >
          <TextField source="code" label="Code AG" />
          <TextFieldWithTooltip
            source="libelle"
            label="Libellé"
            maxLength={100}
          />
          <TextFieldWithTooltip
            source="exercice_libelle"
            label="Exercice(s)"
            maxLength={20}
          />
          <AgDateField label="Date" />
          <CoproManagersField label="Copro managers" />
          <ConvocationStatusField
            label="Convocation"
            source="convocation_triggered_at"
          />
          <StatusField label="Doc signés" source="check_doc_ok" />
          <StatusField label="PV envoyé" source="check_pv_ok" />
          <StatusField label="Check ops" source="check_ops_ok" />
          <StatusField label="Check finance" source="check_finance_ok" />
          <StatusField label="Recours" source="check_recours_ok" />
          <TextField source="archived_reason" label="Raison archivage" />
          <LinkField label="Espace AG" />
        </Datagrid>
      </List>
    </div>
  )
}
